export default function generateRandomKey(): string {
  const uint32: number = window.crypto.getRandomValues(new Uint32Array(1))[0];
  const timestamp = Date.now();
  const xored = uint32 ^ timestamp;
  return xored.toString(16);
}
